/**
 * La paleta ⌘K del Studio (contrato: skill.html): acciones del shell +
 * navegación a las 12 pantallas y — con DATOS REALES — a cada skill del
 * catálogo y cada implantación. Atajo ⌘K/Ctrl+K; «esc» cierra.
 */
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useMsal } from "@azure/msal-react";
import { useTheme } from "@skein/design";
import { Cmdk, type CmdkItem } from "@skein/ui";
import { NAV } from "./nav";
import { nombreCasa } from "../features/implantaciones/casa";
import { useEngagements, useSkills } from "../api/queries";

export function Palette({ open, onClose, onPrefs, onRail }: { open: boolean; onClose: () => void; onPrefs: () => void; onRail: () => void }) {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { toggleLight } = useTheme();
  const skills = useSkills();
  const engagements = useEngagements();
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(0);
  useEffect(() => { if (open) { setQ(""); setSel(0); } }, [open]);

  const all = useMemo<CmdkItem[]>(() => [
    { glyph: "◐", label: "Cambiar tema claro/oscuro", meta: "acción", run: toggleLight },
    { glyph: "◈", label: "Preferencias (marca y tema)", meta: "acción", run: onPrefs },
    { glyph: "⌘", label: "Plegar o desplegar la navegación", meta: "acción", run: onRail },
    { glyph: "×", label: "Cerrar sesión", meta: "acción", run: () => void instance.logoutRedirect() },
    ...NAV.map((n) => ({ glyph: "▣", label: `Ir a ${n.label}`, meta: "navegar", run: () => void navigate({ to: n.to }) })),
    ...(skills.data ?? []).map((s) => ({ glyph: "§", label: `Skill: ${s.slug}`, meta: "navegar", run: () => void navigate({ to: "/skills/$slug", params: { slug: s.slug } }) })),
    ...(engagements.data ?? []).map((e) => ({ glyph: "◆", label: `Implantación: ${nombreCasa(e.engagementId, e.companyName)}`, meta: "navegar", run: () => void navigate({ to: "/implantaciones/$id", params: { id: e.engagementId } }) })),
  ], [toggleLight, onPrefs, onRail, instance, navigate, skills.data, engagements.data]);

  const items = useMemo(() => {
    const query = q.trim().toLowerCase();
    return query ? all.filter((c) => c.label.toLowerCase().includes(query)) : all;
  }, [all, q]);
  useEffect(() => { setSel(0); }, [q]);

  return (
    <Cmdk open={open} className="pos-palette" value={q} onChange={setQ} items={items} selected={Math.min(sel, Math.max(items.length - 1, 0))} onSelected={setSel} onClose={onClose}
      placeholder="Escribe un comando o busca… skills, implantaciones, acciones" />
  );
}
